import { ServerConfiguration } from '@typoas/runtime';
import { API_ENDPOINT } from './api-endpoint';
import { createContext } from './client';
import { MockFetcher } from './api-mock';
import { useMock } from './utils';

const fetcher = useMock ? new MockFetcher() : undefined;

const getAPIEndpoint = () => {
  if (process.env.API_USE_CURRENT_DOMAIN === 'true') {
    const url = new URL(window.location.href);
    return url.origin + url.pathname;
  }

  return API_ENDPOINT;
};

export const apiContext = createContext({
  serverConfiguration: new ServerConfiguration(getAPIEndpoint(), {}),
  fetcher,
});
